module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjE2IiB2aWV3Qm94PSIwIDAgNiAxNiI+CiAgICA8cGF0aCBmaWxsPSIjN0I4QTlEIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zIDBsMyA2LjM4NUgwTDMgMHptMCAxNS40NUwwIDkuMDYzaDZsLTMgNi4zODV6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/controls/dropdown.svg
// module id = ./src/assets/controls/dropdown.svg
// module chunks = 0